import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-tentativo-obbligatorio-conciliazione-view',
  templateUrl: './form-tentativo-obbligatorio-conciliazione-view.component.html',
  styleUrls: ['./form-tentativo-obbligatorio-conciliazione-view.component.css']
})
export class FormTentativoObbligatorioConciliazioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
